export default __webpack_public_path__ + "static/media/iacst-pdf-logo.35b12b4f.png";